import handler from '@/views/moving_function/views/select_goods/handler'

// 加载下一级的分类
async function LoadCategoryData(This, selectedOptions) {
  const targetOption = selectedOptions[selectedOptions.length - 1]
  targetOption.loading = true
  const { type, value } = This.currentItem
  const { list } = await handler.GetCurrentPlatformHandler(type).GetCategoryList({ parentId: targetOption.value, onlyShowTwoCategory: value === 'taoteKeyword2' })
  targetOption.children = list
  targetOption.loading = false
}

// 搜索淘特类目
async function SearchTaoteCategory(This) {
  This.currentItem.params.catId = []
  const item = This.currentItem
  const { list } = await handler.GetCurrentPlatformHandler(item.type).GetCategoryList({ catName: item.catName })
  item.categoryList = list
  if (item.catName) This.$refs.taoteCategoryCascader.$data.sPopupVisible = true
}

export { LoadCategoryData, SearchTaoteCategory }